import styled from 'styled-components'
import { TextWidth, ContentWidth } from '@ta-interaktiv/react-disco-grid'
import { device } from '../breakpoints'
import VideoCover from 'components/VideoCover'

const Header = ({
  title,
  text,
  sup,
  date,
  authors,
  video,
}: {
  title: string
  text: string
  sup: string
  date: Date
  authors: string[]
  video: string
}) => {
  return (
    <Container>
      <VideoCover videoSrc={video} />
      <TextWidth>
        <TitleContainer>
          <Sup>{sup}</Sup>
          <Title>{title}</Title>
        </TitleContainer>
        <Text>{text}</Text>
        <Authors>
          {authors.map((author, index) => (
            <>
              <Link>{author}</Link>
              {index < authors.length - 1 && ', '}
            </>
          ))}
        </Authors>
        <Date>
          <>Mis à jour le {date.toLocaleDateString()}</>
        </Date>
      </TextWidth>
    </Container>
  )
}

const Container = styled.div`
  position: relative;
  text-align: left;
  z-index: 1;
  margin-bottom: 4rem;
`

const TitleContainer = styled.h2`
  margin-top: 0;

  @media ${device.mobileS}, @media ${device.mobileM}, @media ${device.mobileL} {
    margin-bottom: 1.2rem;
    font-size: 3.6rem;
    line-height: 4rem;
  }

  @media ${device.tablet}, @media ${device.laptop} {
    margin-bottom: 1.2rem;
    font-size: 4.9rem;
    line-height: 5.2rem;
  }
`

const Title = styled.span`
  font-family: var(--font-source);
  font-weight: 600;
  display: block;
`

const Text = styled.h3`
  font-family: var(--font-sans-serif);
  font-weight: 400;
  -webkit-font-smoothing: antialiased;

  @media ${device.mobileS}, @media ${device.mobileM}, @media ${device.mobileL} {
    font-size: 1.8rem;
    line-height: 2.7rem;
  }

  @media ${device.tablet}, @media ${device.laptop} {
    font-size: 2rem;
    line-height: 2.9rem;
  }
`

const Sup = styled.span`
  display: inline-block;
  min-width: 85%;
  margin-bottom: 0.8rem;
  font-size: 1.5rem;
  font-family: var(--font-sans-serif);
  line-height: 2rem;
  color: var(--tenant-tdg);

  &:before {
    display: inline-block;
    margin-right: 0.6rem;
    padding: 0.2rem 0.6rem;
    color: #ffffff;
    font-weight: 700;
    font-size: 1.2rem;
    font-family: var(--font-sans-serif);
    line-height: 1.5rem;
    letter-spacing: 0.025rem;
    white-space: nowrap;
    background-color: var(--tenant-tdg);
    content: 'Abo';
  }
`

const Authors = styled.div`
  font-family: var(--font-sans-serif);
  font-size: 1.2rem;
  line-height: 1.2;
  margin-bottom: 1rem;
`

const Link = styled.a`
  text-decoration: underline;
`

const Date = styled.div`
  font-size: 1.2rem;
  font-family: var(--font-sans-serif);
  opacity: 0.5;
  line-height: 1.2;
`

export default Header
